import { UserBrand } from 'types/users';

export type IneligibilityReason = 'social' | 'strategy' | null;

export const NO_SOCIAL_ACCOUNT_TOOLTIP =
    'The brand is not eligible because no social account was found.';
export const NO_STRATEGY_TOOLTIP =
    "This brand doesn't yet have enough strategic context for AI to generate personalized campaign recommendations.";

export const getIneligibilityReason = (
    brand: UserBrand,
    mode: 'prompt' | 'strategy'
): IneligibilityReason => {
    if (!brand.social_account) return 'social';
    if (mode === 'strategy' && !brand.strategy_available) return 'strategy';
    return null;
};

export const getBrandTooltipMessage = (reason: IneligibilityReason): string | null => {
    if (reason === 'social') return NO_SOCIAL_ACCOUNT_TOOLTIP;
    if (reason === 'strategy') return NO_STRATEGY_TOOLTIP;
    return null;
};

export const getBrandInlineStatusMessage = (reason: IneligibilityReason): string | null => {
    if (reason === 'social') return 'No social account found!';
    if (reason === 'strategy') return 'Awaiting strategic context...';
    return null;
};

export const sortBrandsByEligibility = (
    brands: UserBrand[],
    mode: 'prompt' | 'strategy'
): UserBrand[] => {
    return [...brands].sort((a, b) => {
        const aEligible = !getIneligibilityReason(a, mode);
        const bEligible = !getIneligibilityReason(b, mode);
        if (aEligible === bEligible) return 0;
        return aEligible ? -1 : 1;
    });
};
